/**
 * Stub type.
 * tag: 40873
 * @readonly
 * @enum {number} (int)
 */
export enum PaymentStubType {
  /** Initial */
  Initial = 0,
  /** Final */
  Final = 1,
  /** Compounding initial */
  CompoundingInitial = 2,
  /** Compounding final */
  CompoundingFinal = 3,
}
